import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required!"),
  description: Yup.string().required("Description is required!"),
  is_active: Yup.string().required("Status is required!").default("0"),
});
